import BaseService from '@src/services/BaseService'

class LatestCheckinsService extends BaseService {
    constructor() {
        super('dashboards/latest-checkins')
    }
}

export default new LatestCheckinsService()
